module.exports = __webpack_public_path__ + "static/media/fieldRight.4c2bc06a.svg";